import React, { FC } from 'react'
import { TabGroup, TabList } from '@headlessui/react'
import classNames from 'classnames'
import TicketPackSection from '../../TicketPack/TicketPackSection'
import { TabButton } from './TabButton'
import { TabPanels } from './TabPanels'
import { useGiveawayTabs } from './hooks/useGiveawayTabs'

export const GiveawayTabs: FC = () => {
  const {
    tabs,
    activeTab,
    selectedIndex,
    handleTabChange,
    isActive,
    tabsContainerRef,
    desktopTicketContainerRef,
    shouldShowTicketSection,
  } = useGiveawayTabs()

  if (!tabs) return null

  return (
    <div ref={tabsContainerRef} className="mx-auto flex w-full bg-giveaway-background-subtlest-light">
      <div
        className={classNames(
          'relative min-h-screen w-full pb-10 lg:pb-0',
          shouldShowTicketSection ? 'max-w-[960px] ml-auto' : 'max-w-[1440px] mx-auto',
        )}
      >
        <TabGroup selectedIndex={selectedIndex} onChange={handleTabChange}>
          <TabList className="sticky top-0 z-30 flex justify-center gap-8 border-b-2 border-core-gray-300 bg-giveaway-background-subtlest-light pb-4 pt-6">
            {tabs.map((tab) => (
              <TabButton key={tab?.sys.id} tab={tab} activeTab={activeTab} isActive={isActive} />
            ))}
          </TabList>
          <TabPanels />
        </TabGroup>
      </div>

      {shouldShowTicketSection && (
        <TicketPackSection
          ref={desktopTicketContainerRef}
          className="hidden w-full max-w-[480px] lg:mr-auto lg:block"
        />
      )}
    </div>
  )
}
